module.exports = __webpack_public_path__ + "img/thumb_14.30d3e1a1.jpg";